import React from "react";
import { Navigate } from "react-router-dom";
import Details from "../pages/Settings/UserManagement/Users/SelectedUser/index.js";

//login
import Login from "../pages/Authentication/Login";

// Landing Index
import Users from "../pages/Settings/UserManagement/Users/index.js";
import SelectedUser from "../pages/Settings/UserManagement/Users/SelectedUser";
import Roles from "../pages/Settings/UserManagement/Roles/index.js";
import ModuleAccess from "../pages/Settings/UserManagement/ModuleAccess";
import ServiceProvider from "../pages/PSP/ServiceProvider/index.js";
import SelectedServiceProvider from "../pages/PSP/ServiceProvider/SelectedServiceProvider";
import AffinityGroup from "../pages/AG/AffinityGroup";
import SelectedAffinityGroup from "../pages/AG/AffinityGroup/SelectedAffinityGroup/index.js";
import AGMember from "../pages/AGMember/index.js";
import SelectedAgMember from "../pages/AGMember/SelectedAgMember/index.js";

//HUB
import Information from "../pages/Hub/Information";
import Product from "../pages/Product/Product/index.js";
import SelectedProduct from "../pages/Product/Product/SelectedProduct";

//Org
import Organization from "../pages/Org/Organization";
import SelectedOrganization from "../pages/Org/Organization/SelectedOrganization/index.js";
import Profile from "../pages/AGMember/Profile/index.js";
import OrganizationRelationship from "../pages/Org/OrganizationRelationship/index.js";
import Oem from "../pages/Product/Oem/index.js";
import { checkAccessPermission } from "../Utils/CommonUtils.js";
import Order from "../pages/Order/Orders/index.js";
import SelectedOrders from "../pages/Order/Orders/SelectedOrders/index.js";
import Transaction from "../pages/Order/Transaction/index.js";
import AddAffinityGroup from "../pages/AG/AffinityGroup/SelectedAffinityGroup/Details.js";
import ResetPassword from "../pages/Authentication/ResetPassword.js";
import ForgotPassword from "../pages/Authentication/ForgotPassword.js";
import SelectedRoles from "../pages/Settings/UserManagement/Roles/SelectedRoles";
import SelectedOem from "../pages/Product/Oem/SelectedOem/index.js";
import IpSettings from "../pages/IpSettings/IpWhitelisting/index.js";
import Reports from "../pages/Reports/Reports/index.js";
import Qualification from "../pages/IpSettings/Qualifications/Qualification";
import BulkOrder from "../pages/IpSettings/BulkOrder/index.js";

//Order

const authProtectedRoutes = [
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/hub/information" /> },

  // Settings
  {
    path: "/team/user",
    component: <Users />,
    actionType: "VIEW",
    moduleCode: "TEM_USR",
  },
  {
    path: "/team/user/create",
    component: <SelectedUser />,
    actionType: "VIEW",
    moduleCode: "TEM_USR",
  },
  {
    path: "/team/role",
    component: <Roles />,
    actionType: "VIEW",
    moduleCode: "TEM_ROL",
  },
  {
    path: "/team/role/update/:id",
    component: <SelectedRoles />,
    actionType: "VIEW",
    moduleCode: "TEM_ROL",
  },
  {
    path: "/team/user",
    component: <Details />,
    actionType: "VIEW",
    moduleCode: "TEM_USR",
  },
  {
    path: "/team/user/update/:id",
    component: <SelectedUser />,
    actionType: "VIEW",
    moduleCode: "TEM_USR",
  },
  {
    path: "/team/access",
    component: <ModuleAccess />,
    actionType: "VIEW",
    moduleCode: "TEM_ACC",
  },

  // PSP
  {
    path: "/psp/psp",
    component: <ServiceProvider />,
    actionType: "VIEW",
    moduleCode: "PSP_PSP",
  },
  {
    path: "/psp/psp/create",
    component: <SelectedServiceProvider />,
    actionType: "VIEW",
    moduleCode: "PSP_PSP",
  },
  {
    path: "/psp/psp/update/:id",
    component: <SelectedServiceProvider />,
    actionType: "VIEW",
    moduleCode: "PSP_PSP",
  },

  // AG
  {
    path: "/ag/ag",
    component: <AffinityGroup />,
    actionType: "VIEW",
    moduleCode: "AG_AG",
  },
  {
    path: "/ag/ag/create",
    component: <SelectedAffinityGroup />,
    actionType: "VIEW",
    moduleCode: "AG_AG",
  },
  {
    path: "/ag/ag/update/:id",
    component: <SelectedAffinityGroup />,
    actionType: "VIEW",
    moduleCode: "AG_AG",
  },
  {
    path: "/agmember/member",
    component: <AGMember />,
    actionType: "VIEW",
    moduleCode: "AGM_MEM",
  },
  {
    path: "/agmember/member/update/:id",
    component: <SelectedAgMember />,
    actionType: "VIEW",
    moduleCode: "AGM_MEM",
  },
  {
    path: "/agmember/member/profile",
    component: <Profile />,
    // actionType: "VIEW",
    // moduleCode: "UPI_DSB",
  },
  //HUB routes
  {
    path: "/hub",
    // component: <Information />,
    actionType: "VIEW",
    moduleCode: "HUB",
  },
  {
    path: "/hub/information",
    component: <Information />,
    actionType: "VIEW",
    moduleCode: "HUB_INFO",
  },

  //PROD routes
  {
    path: "/prod/product",
    component: <Product />,
    actionType: "VIEW",
    moduleCode: "PROD_PRO",
  },
  {
    path: "/prod/product/create",
    component: <SelectedProduct />,
    actionType: "VIEW",
    moduleCode: "PROD_PRO",
  },
  {
    path: "/prod/product/update/:id",
    component: <SelectedProduct />,
    actionType: "VIEW",
    moduleCode: "PROD_PRO",
  },
  {
    path: "/prod/oem",
    component: <Oem />,
    actionType: "VIEW",
    moduleCode: "PROD_OEM",
  },
  {
    path: "/prod/oem/update/:id",
    component: <SelectedOem />,
    actionType: "VIEW",
    moduleCode: "TEM_ROL",
  },
  //Org
  {
    path: "/org/org",
    component: <Organization />,
    actionType: "VIEW",
    moduleCode: "ORG_ORG",
  },
  {
    path: "/org/org/update/:id",
    component: <SelectedOrganization />,
    actionType: "VIEW",
    moduleCode: "ORG_ORG",
  },
  //OrgRelation
  {
    path: "/org/relationship",
    component: <OrganizationRelationship />,
    actionType: "VIEW",
    moduleCode: "ORG_RL",
  },
  // Order
  {
    path: "/order",
    // component: <Information />,
    actionType: "VIEW",
    moduleCode: "ORD",
  },
  {
    path: "/order/orders",
    component: <Order />,
    actionType: "VIEW",
    moduleCode: "ORD_ORDS",
  },
  {
    path: "/order/orders/create",
    component: <SelectedOrders />,
    actionType: "VIEW",
    moduleCode: "ORD_ORDS",
  },
  {
    path: "/order/orders/update/:id",
    component: <SelectedOrders />,
    actionType: "VIEW",
    moduleCode: "ORD_ORDS",
  },
  {
    path: "/order/transaction",
    component: <Transaction />,
    actionType: "VIEW",
    moduleCode: "ORD_TXN",
  },

  //IP Settings
  {
    path: "/settings/ipwhitelisting",
    component: <IpSettings />,
    actionType: "VIEW",
    moduleCode: "SETN_IPWL",
  },
  {
    path: "/report/reports",
    component: <Reports />,
    actionType: "VIEW",
    moduleCode: "REPO",
  },
  {
    path: "/settings/qualification",
    component: <Qualification />,
    actionType: "VIEW",
    moduleCode: "SETN_QUAL",
  },
  {
    path: "/settings/bulkorder",
    component: <BulkOrder />,
    actionType: "VIEW",
    moduleCode: "SETN_BULK",
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/", component: <Login /> },
  { path: "/reset", component: <ResetPassword /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
];

export { authProtectedRoutes, publicRoutes };

// import React from "react";
// import { Navigate } from "react-router-dom";
// import Details from "../pages/Settings/UserManagement/Users/SelectedUser/index.js";

// //login
// import Login from "../pages/Authentication/Login";
// import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
// import Logout from "../pages/Authentication/Logout";
// import Register from "../pages/Authentication/Register";

// // Landing Index
// import Users from "../pages/Settings/UserManagement/Users/index.js";
// import SelectedUser from "../pages/Settings/UserManagement/Users/SelectedUser";
// import Roles from "../pages/Settings/UserManagement/Roles/index.js";
// import ModuleAccess from "../pages/Settings/UserManagement/ModuleAccess";
// import ServiceProvider from "../pages/PSP/ServiceProvider/index.js";
// import SelectedServiceProvider from "../pages/PSP/ServiceProvider/SelectedServiceProvider";
// import AffinityGroup from "../pages/AG/AffinityGroup";
// import SelectedAffinityGroup from "../pages/AG/AffinityGroup/SelectedAffinityGroup/index.js";
// import AGMember from "../pages/AGMember/index.js";
// import SelectedAgMember from "../pages/AGMember/SelectedAgMember/index.js";

// //HUB
// import Information from "../pages/Hub/Information";
// import Product from "../pages/Product/Product/index.js";
// import SelectedProduct from "../pages/Product/Product/SelectedProduct";

// //Org
// import Organization from "../pages/Org/Organization";
// import SelectedOrganization from "../pages/Org/Organization/SelectedOrganization/index.js";
// import Profile from "../pages/AGMember/Profile/index.js";
// import OrganizationRelationship from "../pages/Org/OrganizationRelationship/index.js";
// import Oem from "../pages/Product/Oem/index.js";
// import { checkAccessPermission } from "../Utils/CommonUtils.js";

// const withAccessControl = (Component, actionType, moduleCode) => {
//   return (props) => {
//     const sidebarState = useSelector((state) => state.sidebar);

//     const hasPermission = checkAccessPermission(actionType, moduleCode, sidebarState);

//     return hasPermission ? <Component {...props} /> : <Navigate to="/access-denied" />;
//   };
// };

// const authProtectedRoutes = [
//   {
//     path: "/",
//     exact: true,
//     component: <Navigate to="/dashboard" />,
//   },
//   { path: "*", component: <Navigate to="/hub/information" /> },

//   // Settings
//   {
//     path: "/team/user",
//     // component: <Users />,
//     component: checkAccessPermission("VIEW", "TEM_USR") ? <Users /> : null,
//   },
//   {
//     path: "/team/user/create",
//     // component: <SelectedUser />,
//     component: checkAccessPermission("VIEW", "TEM_USR") ? (
//       <SelectedUser />
//     ) : null,
//   },
//   {
//     path: "/team/role",
//     // component: <Roles />,
//     component: checkAccessPermission("VIEW", "TEM_ROL") ? <Roles /> : null,
//   },
//   {
//     path: "/team/user",
//     // component: <Details />,
//     component: checkAccessPermission("VIEW", "TEM_USR") ? <Details /> : null,
//   },
//   {
//     path: "/team/user/update/:id",
//     // component: <SelectedUser />,
//     component: checkAccessPermission("VIEW", "TEM_USR") ? (
//       <SelectedUser />
//     ) : null,
//   },
//   {
//     path: "/team/access",
//     component: <ModuleAccess />,
//     // component: checkAccessPermission("VIEW", "TEM_ACC") ? <ModuleAccess /> : null,
//   },

//   // PSP
//   {
//     path: "/psp/psp",
//     // component: <ServiceProvider />,
//     component: checkAccessPermission("VIEW", "PSP_PSP") ? (
//       <ServiceProvider />
//     ) : null,
//   },
//   {
//     path: "/psp/psp/create",
//     // component: <SelectedServiceProvider />,
//     component: checkAccessPermission("VIEW", "PSP_PSP") ? (
//       <SelectedServiceProvider />
//     ) : null,
//   },
//   {
//     path: "/psp/psp/update/:id",
//     // component: <SelectedServiceProvider />,
//     component: checkAccessPermission("VIEW", "PSP_PSP") ? (
//       <SelectedServiceProvider />
//     ) : null,
//   },

//   // AG
//   {
//     path: "/ag/ag",
//     // component: <AffinityGroup />,
//     component: checkAccessPermission("VIEW", "AG_AG") ? (
//       <AffinityGroup />
//     ) : null,
//   },
//   {
//     path: "/ag/ag/create",
//     // component: <SelectedAffinityGroup />,
//     component: checkAccessPermission("VIEW", "AG_AG") ? (
//       <SelectedAffinityGroup />
//     ) : null,
//   },
//   {
//     path: "/ag/ag/update/:id",
//     // component: <SelectedAffinityGroup />,
//     component: checkAccessPermission("VIEW", "AG_AG") ? (
//       <SelectedAffinityGroup />
//     ) : null,
//   },
//   {
//     path: "/agmember/member",
//     component: <AGMember />,
//   },
//   {
//     path: "/agmember/member/update/:id",
//     component: <SelectedAgMember />,
//   },
//   {
//     path: "/agmember/member/profile",
//     component: <Profile />,
//   },
//   //HUB routes
//   {
//     path: "/hub/information",
//     component: <Information />,
//     // component: withAccessControl(Information, "VIEW", "HUB_INFO"),
//     // component: () => checkAccessPermission("VIEW", "HUB_INFO") ? <Information /> : null,
//     actionType: "VIEW",
//     moduleCode: "HUB_INFO",
//   },

//   //PROD routes
//   {
//     path: "/prod/product",
//     // component: <Product />,
//     component: checkAccessPermission("VIEW", "PROD_PRO") ? (
//       <Product />
//     ) : (
//       <Navigate to="" />
//     ),
//   },
//   {
//     path: "/prod/product/create",
//     // component: <SelectedProduct />,
//     component: checkAccessPermission("VIEW", "PROD_PRO") ? (
//       <SelectedProduct />
//     ) : (
//       <Navigate to="" />
//     ),
//   },
//   {
//     path: "/prod/product/update/:id",
//     // component: <SelectedProduct />,
//     component: checkAccessPermission("VIEW", "PROD_PRO") ? (
//       <SelectedProduct />
//     ) : (
//       <Navigate to="" />
//     ),
//   },
//   {
//     path: "/prod/oem",
//     // component: <Oem />,
//     component: checkAccessPermission("VIEW", "PROD_OEM") ? (
//       <Oem />
//     ) : (
//       <Navigate to="" />
//     ),
//   },

//   //Org
//   {
//     path: "/org/org",
//     // component: <Organization />,
//     component: checkAccessPermission("VIEW", "ORG_ORG") ? (
//       <Organization />
//     ) : (
//       <Navigate to=""/>
//     ),
//   },
//   {
//     path: "/org/org/update/:id",
//     // component: <SelectedOrganization />,
//     component: checkAccessPermission("VIEW", "ORG_ORG") ? (
//       <SelectedOrganization />
//     ) : (
//       <Navigate to="" />
//     ),
//   },
//   //OrgRelation
//   {
//     path: "/org/relationship",
//     // component: <OrganizationRelationship />,
//     component: checkAccessPermission("VIEW", "ORG_RL") ? (
//       <OrganizationRelationship />
//     ) : (
//       <Navigate to="" />
//     ),
//   },
// ];

// const publicRoutes = [
//   // Authentication Page
//   { path: "/logout", component: <Logout /> },
//   { path: "/", component: <Login /> },
//   { path: "/forgot-password", component: <ForgetPasswordPage /> },
//   { path: "/register", component: <Register /> },
// ];

// export { authProtectedRoutes, publicRoutes };
